var module = angular.module('octopusApp.projects');

module.directive('channelEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/channels/channel_editor.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/channel_editor.js
// module id = 8570792040928819
// module chunks = 1